export default __webpack_public_path__ + "static/media/IdNumber.f55ffebc.svg";